
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/discounts",
      function () {
        return require("private-next-pages/help/discounts.tsx");
      }
    ]);
  